import { DecimalPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { OnyxFlagComponent } from '../../flags/onyx-flag/onyx-flag.component';
import type { OnyxIconName } from '../../icons/interfaces';
import { OnyxIconComponent } from '../../icons/onyx-icon/onyx-icon.component';
import { OnyxSpinnerComponent } from '../../spinner/onyx-spinner/onyx-spinner.component';

@Component({
  selector: 'onyx-tag',
  imports: [
    OnyxIconComponent,
    OnyxSpinnerComponent,
    DecimalPipe,
    OnyxFlagComponent,
  ],
  templateUrl: './onyx-tag.component.html',
  styleUrl: './onyx-tag.component.scss',
})
export class OnyxTagComponent {
  public readonly color = input.required<
    'gray' | 'light-gray' | 'white' | 'blue' | 'green' | 'red' | 'light-red'
  >();
  public readonly size = input<24 | 32>(32);
  public readonly icon = input<OnyxIconName | null>(null);
  public readonly flag = input<string | null>(null);
  public readonly count = input<number | null>(null);
  public readonly loading = input(false);
  public readonly disabled = input(false);
  public readonly inactive = input(false);
}
